/**
 * Media Layer Constants
 */

import type { PlayerStyles } from '../types'

/** Placeholder image URL for audio files without a cover image */
export const AUDIO_FILE_PLACEHOLDER = 'https://storage.googleapis.com/revex-membership-production/assets/audio-placeholder.svg'

/** Default thumbnail for audio lessons in fullSize mode */
export const AUDIO_LESSON_THUMBNAIL = 'https://storage.googleapis.com/revex-membership-staging/assets/audio-lesson-thumbnail.webp'

/** Base URL for Firebase Storage (used to detect and skip Firebase Storage URLs in CDN replacement) */
export const FIREBASE_STORAGE_BASE_URL = 'https://firebasestorage.googleapis.com'

/** Default controls and surface colors for DRM video playback */
export const DEFAULT_DRM_PLAYER_STYLES: PlayerStyles = {
  controlsBgColor: 'linear-gradient(to top, #00000040, #00000000)',
  primaryColor: '#d7d7d799',
  borderRadius: '0.375rem',
  menuBgColor: '#ffffff',
  textColor: '#lightgray',
  volumeBgColor: 'transparent',
  videoBgColor: '#000000',
}
